import * as base from 'store/bolt/pixels.js';
import Store from 'store/store';

function firePageLoad() {
	let {
		activePage,
		appData: {
			meta: {
				title: {
					en: movieName
				},
				dates: {
					release: releaseDate
				},
				region: {
					slug
				},
				movieIMDBID,
				dataLayer = {}
			}
		}
	} = Store.get();

	if (activePage.startsWith('bolt')) {
		activePage = activePage.replace('bolt', '');
	}

	let {
		imdb_id
	} = dataLayer || {};


	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'Landing',
		'site': {
			'name': `${movieName} Movie - Showtimes Site`,
			'market': slug,
			'template': 'Powster'
		},
		'page': {
			'name': activePage,
			'type': 'Showtimes'
		},
		'movie': {
			'name': movieName,
			'release_date': releaseDate,
			'imdb_id': imdb_id || movieIMDBID || '-'
		}
	});
	console.log('firePageLoad', window.dataLayer);
}

Store.on('LANDING', () => {
	firePageLoad();
});